import { createEntityStore, type EntityState, type EntityStore } from '@datorama/akita';
import { type TaxonomyContribution } from 'types/models';

export type TaxonomyContributionsState = EntityState<TaxonomyContribution>;

const store: EntityStore<TaxonomyContributionsState> = createEntityStore(
   {},
   {
      resettable: true,
      name: 'taxonomy/contributions',
   }
);

export default store;
